export default "__VITE_ASSET__D$ZgGIrB__"